import axios, { AxiosError } from 'axios';
import * as React from 'react';
import { requestUnsubscribeFromWebhook } from '../asyncHelpers/googleAuthService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

export default function useAsyncGoogleUnsubscribeToWebhook() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);
    const [responseBody, setResponseBody] = React.useState<string>('');

    const asyncGoogleUnsubscribeToWebhook = async (): Promise<void> => {
        try {
            setResponseBody('');
            setRequestStatus(RequestStatus.active);

            const { data } = await requestUnsubscribeFromWebhook(request_token.token);

            setRequestStatus(RequestStatus.success);
        } catch (e: any) {
            if (!axios.isCancel(e)) {
                //in case user already exists
                if (axios.isAxiosError(e)) {
                    const error = e as AxiosError;
                    if (e.response?.status == 400 || e.response?.status == 404) {
                        /* Notify user of failed http request */
                        const toastData = createErrorToast(e.response.data);

                        setResponseBody(e.response.data);

                        dispatch(createToast({ toastData }));
                    }
                }

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncGoogleUnsubscribeToWebhook,
        responseBody,
    };
}
